var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5H11.5C11.0875 14.5 10.75 14.1625 10.75 13.75C10.75 13.3375 11.0875 13 11.5 13H17.5C17.9125 13 18.25 13.3375 18.25 13.75C18.25 14.1625 17.9125 14.5 17.5 14.5Z",
    fill: "#1777CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50805 10.3633L5.46818 12.8794C5.23928 13.4402 4.50679 13.4402 4.27789 12.8794L3.23802 10.3633L0.948999 9.2202C0.438875 8.96139 0.438875 8.16341 0.948999 7.91179L3.23802 6.76873L4.27789 4.25256C4.51333 3.69181 5.23928 3.69181 5.46818 4.25256L6.50805 6.76873L8.79707 7.91179C9.3072 8.17059 9.3072 8.96858 8.79707 9.2202L6.50805 10.3633ZM11.1123 5.69037L10.5956 4.43228L9.45108 3.86435C9.19601 3.73494 9.19601 3.33955 9.45108 3.21014L10.5956 2.64221L11.1123 1.37693C11.23 1.09656 11.5897 1.09656 11.7074 1.37693L12.2241 2.63502L13.3751 3.20295C13.6302 3.33236 13.6302 3.72776 13.3751 3.85716L12.2306 4.42509L11.7139 5.69037C11.5962 5.97074 11.23 5.97074 11.1123 5.69037Z",
    fill: "#1777CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotRemove);
export default __webpack_public_path__ + "static/media/copilot-remove.31d98e2b35fcfdabcbfe9e325dde08c2.svg";
export { ForwardRef as ReactComponent };